import { z } from 'zod';

export const CustomerInfoSchema = z.object({
    constructionProjectId: z.string().uuid(),
    organizationId: z.number(),
    userId: z.number(),
    manualCostCenter: z.string().trim().nonempty().optional(),
});
